import { AttachmentParams } from './types';

/**
 * Canonicalize S3 presigned POST URLs (ensure trailing slash) so attachment
 * uploads work with stable CSP connect-src allowlists across org instances.
 */
export const normalizeAttachmentUploadUrl = (url: string): string => {
  if (!url) return url;
  return `${url.replace(/\/+$/, '')}/`;
};

/** Chat widget: 50MB total, no per-file limit (single file can be up to 50MB). */
const CHAT_MAX_TOTAL_ATTACHMENT_BYTES = 50 * 1024 * 1024;

export const validateFile = (file: File) => {
  const fileSize = file.size;

  if (fileSize > CHAT_MAX_TOTAL_ATTACHMENT_BYTES)
    return new Error('Individual attachment file size is greater than 50MB');

  return undefined;
};

export const validateFiles = (files: File[]) => {
  let totalFileSize = 0;
  let invalidFileError;

  files.every((file) => {
    totalFileSize += file.size;
    invalidFileError = validateFile(file);

    if (invalidFileError) return false;

    return true;
  });

  if (invalidFileError) return invalidFileError;

  if (totalFileSize > CHAT_MAX_TOTAL_ATTACHMENT_BYTES)
    return new Error('Total attachments file size is greater than 50MB');

  return undefined;
};

export const validateAttachments = (attachments: AttachmentParams[]) => {
  const invalidAttachment = attachments.find((attachment) => !attachment.file);

  if (invalidAttachment)
    return new Error(
      'Attachment is missing one or more of the required properties: file',
    );

  const files = attachments.map((attachment) => attachment.file);
  const invalidFilesError = validateFiles(files);

  if (invalidFilesError) return invalidFilesError;

  return undefined;
};
